var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefreshIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6337 2.35292C12.0037 0.722922 9.69366 -0.217078 7.15366 0.0429219C3.48366 0.412922 0.463664 3.39292 0.0536639 7.06292C-0.496336 11.9129 3.25366 16.0029 7.98366 16.0029C11.1737 16.0029 13.9137 14.1329 15.1937 11.4429C15.5137 10.7729 15.0337 10.0029 14.2937 10.0029C13.9237 10.0029 13.5737 10.2029 13.4137 10.5329C12.2837 12.9629 9.57366 14.5029 6.61366 13.8429C4.39366 13.3529 2.60366 11.5429 2.13366 9.32292C1.29366 5.44292 4.24366 2.00292 7.98366 2.00292C9.64366 2.00292 11.1237 2.69292 12.2037 3.78292L10.6937 5.29292C10.0637 5.92292 10.5037 7.00292 11.3937 7.00292H14.9837C15.5337 7.00292 15.9837 6.55292 15.9837 6.00292V2.41292C15.9837 1.52292 14.9037 1.07292 14.2737 1.70292L13.6337 2.35292Z",
    fill: "#41DBFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.63a04525983f271f70bb4f36f5975827.svg";
export { ForwardRef as ReactComponent };